import { useState, useRef, useEffect, useCallback, memo } from "react"

import { useUI } from "providers/UIProvider"

import { ISearchbarProps } from "./SearchbarTypes"

import { useOutsideClick } from "@chakra-ui/react"
import { Box, Flex, Text, Center } from "@chakra-ui/react"

import Icon from "components/UI/atoms/Icon"
import Input from "components/UI/atoms/Input"

const Searchbar: React.FC<ISearchbarProps> = ({ value, onChange, onSearchBtnClick = () => {}}) => {
  const { T } = useUI()

  const [inputMode, setInputMode] = useState<boolean>(false)

  const searchBarElement = useRef<any>(null)
  useOutsideClick({
    ref: searchBarElement,
    handler: () => setInputMode(false),
  })

  const handleSearchbarClick = useCallback(()=>{
    setInputMode(true)
  }, [])

  useEffect(()=>{
    if(value !== "" && value !== undefined) {
      setInputMode(true)
    }
  },[value])
  
  return (
    <Flex
      as="button"
      cursor="pointer"
      backgroundColor="white"
      borderRadius="base"
      boxShadow="primary"
      fontSize="xl"
      color="main_text_color"
      w={`${inputMode ? "300px" : "141px"}`}
      h="63px"
      onClick={handleSearchbarClick}
      position="relative"
      transition=".3s ease"
      ref={searchBarElement}
    >
      <Flex alignItems="center" h="100%">
        <Box ml="17px">
          <Box
            position="absolute"
            top="50%"
            left="20px"
            transform="translateY(-50%)"
            visibility={`${inputMode ? "visible" : "hidden"}`}
            opacity={`${inputMode ? "1" : "0"}`}
            transition="opacity .3s ease"
            transitionDelay=".1s"
          >
            <Input
              id="bookings-searchbar"
              name="bookings"
              value={value}
              placeholder={T("general.search")}
              onChange={onChange}
              type="string"
              styles={{ width: "100%", height: "40px" }}
              autoFocus
            />
          </Box>
          <Text
            visibility={`${inputMode ? "hidden" : "visible"}`}
            opacity={`${inputMode ? "0" : "1"}`}
          >
            {T("general.search")}
          </Text>
        </Box>
        <Center
          w="34px"
          h="34px"
          backgroundColor="primary"
          borderRadius="50%"
          position="absolute"
          top="50%"
          right="20px"
          transform="translateY(-50%)"
          onClick={onSearchBtnClick}
        >
          <Icon name="search" />
        </Center>
      </Flex>
    </Flex>
  )
}

export default memo(Searchbar)
